// src/pages/ExplorePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import PostCard from '../components/posts/PostCard';
import '../styles/explore-page.css';

const ExplorePage = () => {
  const [activeTab, setActiveTab] = useState('discover');
  const [posts, setPosts] = useState([]);
  const [users, setUsers] = useState([]);
  const [trending, setTrending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    fetchContent();
  }, [activeTab]);
  
  const fetchContent = async () => {
    try {
      setLoading(true);
      
      switch (activeTab) {
        case 'discover':
          const postsResponse = await api.get('/api/feeds/discover');
          setPosts(postsResponse.data.posts);
          break;
          
        case 'people':
          const usersResponse = await api.get('/api/users/suggestions');
          setUsers(usersResponse.data.suggestions);
          break;
          
        case 'trending':
          const hashtagsResponse = await api.get('/api/feeds/trending', {
            params: { timeRange: '24h' }
          });
          setTrending(hashtagsResponse.data.posts);
          break;
          
        default:
          break;
      }
    } catch (err) {
      console.error('Error fetching explore content:', err);
      setError('Failed to load content');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="explore-page">
      <h1 className="page-title">Explore</h1>
      
      <div className="explore-tabs">
        <button
          className={`tab-button ${activeTab === 'discover' ? 'active' : ''}`}
          onClick={() => setActiveTab('discover')}
        >
          Discover
        </button>
        
        <button
          className={`tab-button ${activeTab === 'people' ? 'active' : ''}`}
          onClick={() => setActiveTab('people')}
        >
          People
        </button>
        
        <button
          className={`tab-button ${activeTab === 'trending' ? 'active' : ''}`}
          onClick={() => setActiveTab('trending')}
        >
          Trending
        </button>
      </div>
      
      {error && <div className="error-message">{error}</div>}
      
      {loading ? (
        <div className="loading">Loading content...</div>
      ) : (
        <div className="explore-content">
          {activeTab === 'discover' && (
            <>
              {posts.length > 0 ? (
                posts.map(post => <PostCard key={post.id} post={post} />)
              ) : (
                <div className="empty-state">
                  <h3>No posts to discover</h3>
                  <p>Check back later for interesting content</p>
                </div>
              )}
            </>
          )}
          
          {activeTab === 'people' && (
            <div className="user-suggestions">
              {users.length > 0 ? (
                users.map(user => (
                  <div key={user.id} className="user-card">
                    <div className="user-card-header">
                      <Link to={`/profile/${user.username}`} className="user-avatar-link">
                        <img 
                          src={user.profilePic || '/default-avatar.png'} 
                          alt={user.username}
                          className="user-avatar" 
                        />
                      </Link>
                      
                      <div className="user-info">
                        <Link to={`/profile/${user.username}`} className="user-name">
                          {user.displayName || user.username}
                        </Link>
                        <span className="user-username">@{user.username}</span>
                      </div>
                    </div>
                    
                    {user.bio && <p className="user-bio">{user.bio}</p>}
                    
                    <Link to={`/profile/${user.username}`} className="view-profile-link">
                      View Profile
                    </Link>
                  </div>
                ))
              ) : (
                <div className="empty-state">
                  <h3>No suggestions right now</h3>
                  <p>Check back later for people to follow</p>
                </div>
              )}
            </div>
          )}
          
          {activeTab === 'trending' && (
            <>
              {trending.length > 0 ? (
                trending.map(post => <PostCard key={post.id} post={post} />)
              ) : (
                <div className="empty-state">
                  <h3>No trending posts</h3>
                  <p>Check back later for what's popular</p>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ExplorePage;